<template>
  <div v-if="data.length" class="analytics-chart">
    <analytics-area-chart :chart-data="getChartData" :options="getChartOptions"></analytics-area-chart>
  </div>
</template>

<script>
import colorMixin from '@/mixins/colors';
import moment from 'moment';

import AnalyticsAreaChart from './AnalyticsAreaChart';

export default {
  name: 'AnalyticsTimeSeriesAreaChart',
  mixins: [colorMixin],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    tension: {
      type: Number,
      default: 0.1,
    },
    timeFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
    legendPosition: {
      type: String,
      default: 'bottom',
    },
    borderWidth: {
      type: Number,
      default: 1,
    },
    unit: {
      type: String,
      required: true,
    },
  },
  components: {
    AnalyticsAreaChart,
  },
  computed: {
    getDateFormat() {
      if (this.unit === 'hour') {
        return 'HH:MM';
      }

      return 'YYYY-MM-DD';
    },
    getChartData() {
      if (!this.data.length) {
        return {};
      }

      const sets = {};
      this.data.slice(1).forEach(data => {
        const key = data[0];
        sets[key] = data.slice(1);
      });

      const formattedDateLabels = this.data[0].map(dateItem => {
        if (!dateItem.includes('x')) {
          return moment(dateItem).format(this.getDateFormat);
        }
        return '0';
      });
      const chartData = {
        labels: formattedDateLabels.filter(dateItem => dateItem !== '0'),
        datasets: Object.keys(sets).map(key => ({
          label: key,
          backgroundColor: this.generateRGBAColor(key, 0.5),
          borderColor: this.generateRGBAColor(key, 1),
          pointBackgroundColor: this.generateRGBAColor(key, 1),
          pointBorderColor: '#fff',
          borderWidth: this.borderWidth,
          data: sets[key],
        })),
      };
      return chartData;
    },

    getChartOptions() {
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.showLegend,
          position: this.legendPosition,
        },
        elements: {
          line: {
            tension: this.tension,
          },
        },
        scales: {
          xAxes: [
            {
              type: 'time',
              time: {
                format: this.getDateFormat,
                unit: this.unit,
              },
            },
          ],
        },
      };

      return options;
    },
  },
};
</script>



// WEBPACK FOOTER //
// AnalyticsTimeSeriesAreaChart.vue?d1f25e20